import Link from "next/link";
import styles from "./style.module.scss";
import * as Icon from "@/components/tools/icons";

type Props = {
  children?: React.ReactNode;
  href?: string;
};

export default function TableRow({ children, href }: Props) {
  return (
    <div className={styles.tablerow}>
      <div className={styles.content}>{children}</div>
      {href && (
        <div className={styles.button}>
          <Link href={`${href}`}>
            <Icon.Chevron />
          </Link>
        </div>
      )}
    </div>
  );
}
